import stemmer from "stemmer";
import getReadyScoresForRun from "../score_passes/score_pass_1";
import getFrustrationScoreForRun from "../score_passes/score_pass_2";
import selectWord from "../intervene_selector";
import getConfigForLocale from "../config/getConfigForLocale";

// Return metadata for a word in the current phrase
export function getWordMetadata(chosenWord, state) {
  let words = state.phraseWordMetadata;
  return words.find((word) => {
    return (
      word.WORD.replace("'", "").replace(",", "") ==
      chosenWord.toUpperCase().replace("'", "").replace(",", "")
    );
  });
}

// Set corresponding word metadata fields for a word that we'll intervene on
// Note: these fields are only generated for word level interventions
export function createSelectedWordFields(wordToInterveneOn, state) {
  if (!wordToInterveneOn) {
    return;
  }
  let words = state.phraseWordMetadata;
  let wordFields = words.find((word) => {
    if (!word || !word.WORD) {
      return false;
    }

    return (
      word.WORD.replace("'", "").replace(",", "") ==
      wordToInterveneOn.toUpperCase().replace("'", "").replace(",", "")
    );
  });

  if (wordFields) {
    Object.keys(wordFields).forEach((key) => {
      if (key != "WORD") {
        state["word_" + key] = wordFields[key];
      }
    });
  }

  // Add closeError data if it exists in closeErrors array
  setCloseErrorData(wordToInterveneOn, state);
}

function setCloseErrorData(word, state) {
  const closeErrors = state.closeErrors;
  if (!closeErrors || closeErrors.length === 0) {
    return;
  }

  let closeError;
  const wordIndex = state.wordIndex;

  closeError = closeErrors.find((error) => {
    return error.index === wordIndex;
  });

  if (
    !closeError ||
    closeError.desiredWord.replace("'", "").replace(",", "").toUpperCase() !==
      word.replace("'", "").replace(",", "").toUpperCase()
  ) {
    closeError = closeErrors.find((error) => {
      return (
        error.desiredWord.replace("'", "").replace(",", "").toUpperCase() ==
        word.replace("'", "").replace(",", "").toUpperCase()
      );
    });
  }

  if (closeError) {
    state.closeError = closeError;

    if (stemmer(closeError.desiredWord) === stemmer(closeError.utteredWord)) {
      state.tenseError = closeError;
    }
  }
}

//NOTE: this takes a state which has already been transformed by the heuristicTransformer in studentapp-agent.
//      This transformation cannot be done here because it is in a separate npm package.
//      Remember to run any test data through that transformer before using it in this module
export function prepTransformedStateForRun(transformedState) {
  let passConfigs = getConfigForLocale(transformedState.locale); // assign configs the default setting
  let state = JSON.parse(JSON.stringify(transformedState));
  state.scores = {};
  getReadyScoresForRun(state, passConfigs);
  getFrustrationScoreForRun(state, passConfigs); // Score pass #2
  selectWord(state);
  return state;
}
